import { IncidentActionTypes, } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const createIncident = createAsyncMapAction(IncidentActionTypes.CREATE_INCIDENT, p => p.requestId);
export const listLatestIncidents = createAsyncMapAction(IncidentActionTypes.LIST_LATEST_INCIDENTS, p => p.userId);
export const removeIncident = createAsyncMapAction(IncidentActionTypes.REMOVE_INCIDENT, p => p.requestId);
export const updateIncident = createAsyncMapAction(IncidentActionTypes.UPDATE_INCIDENT, p => p.requestId);
export const clearIncidents = createAsyncMapAction(IncidentActionTypes.CLEAR_INCIDENTS, p => p.requestId);
